export const getParameterByName = (name, url) => {
  const match = RegExp('[?&]' + name + '=([^&]*)').exec(url)
  return match && decodeURIComponent(match[1])
  // return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
